const mobileSearchIcon = document.querySelector('#mobile-search-icon');
const desktopSearchIcon = document.querySelector('#desktop-search-icon');
const searchBar = document.querySelector('#search-bar');
const searchInput = document.querySelector('#search-input');
const searchCloseButton = document.querySelector('#search-close-button');
const searchResults = document.querySelector('#search-results');
const searchOverlay = document.querySelector('#search-overlay');


// Limit to 5 recent searches

// Initialize debounce timer
let debounceTimer;

// EXCLUDE PAGES AND COLLECTIONS FROM SEARCH RESULTS
// Add page handles or collection handles that should not appear in search results
// Example: 'pages/welcome-new-customer', 'collections/hidden-collection'
const excludedFromSearch = [
  // Add your excluded pages and collections here
  // 'pages/welcome-new-customer',
  // 'collections/private-collection',
  // 'pages/admin-only'
  "pages/welcome-new-customer",
];

// Store and retrieve recent searches
function getRecentSearches() {
  try {
    const recentSearches = localStorage.getItem('recentSearches');
    return recentSearches ? JSON.parse(recentSearches) : [];
  } catch (e) {
    console.error('Error retrieving recent searches:', e);
    return [];
  }
}

function addToRecentSearches(item) {
  try {
    const recentSearches = getRecentSearches();
    
    // Check if item already exists in recent searches
    const existingIndex = recentSearches.findIndex(search => search.url === item.url);
    
    // If item exists, remove it (we'll add it to the front later)
    if (existingIndex !== -1) {
      recentSearches.splice(existingIndex, 1);
    }
    
    // Add item to the beginning of the array
    recentSearches.unshift(item);
    
    // Limit to 5 recent searches
    const limitedSearches = recentSearches.slice(0, 5);
    
    // Save to localStorage
    localStorage.setItem('recentSearches', JSON.stringify(limitedSearches));
  } catch (e) {
    console.error('Error saving recent searches:', e);
  }
}

// Handle search functionality
async function performSearch(query) {
  // Clear results if query is empty or less than 2 characters
  if (!query || query.length < 2) {
    searchResults.style.display = 'none';
    searchResults.innerHTML = '';
    return;
  }

  // set it to display - block in the future
  // Show search results container
  searchResults.style.display = 'block';

  // Show loading indicator
  searchResults.innerHTML = '<div class="search-loading">Suchen...</div>';

  // Construct the search URL
  const searchUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,page,collection&resources[limit]=4&resources[options][fields]=title,product_type,variants.title,variants.sku&resources[options][unavailable_products]=show`;

  try {
    const response = await fetch(searchUrl);
    const data = await response.json();

    let resultsHTML = '';
    
    // Get recent searches for display
    const recentSearches = getRecentSearches();
    const hasRecentSearches = recentSearches.length > 0;
    
    // Create a container div with two columns
    resultsHTML = '<div class="search-results-container">';
    
    // Add recent searches column if we have any
    if (hasRecentSearches) {
      resultsHTML += '<div class="search-results-column recent-searches">';
      resultsHTML += '<div class="search-results-group"><h3>Letzte Suchen</h3><ul>';
      
      recentSearches.forEach(item => {
        const itemImage = item.image ? `<img src="${item.image}" alt="${item.title}" class="search-result-image">` : '';
        const price = item.price ? `<span class="search-result-price">${item.price}</span>` : '';
        const sku = item.sku ? `<span class="search-result-sku">SKU: ${item.sku}</span>` : '';
        const type = item.type ? `<span class="search-result-type">${item.type}</span>` : '';
        
        resultsHTML += `
          <li class="search-result-item">
            <a href="${item.url}" class="search-result-link">
              ${itemImage}
              <div class="search-result-details">
                <span class="search-result-title">${item.title}</span>
                ${type}
                ${sku}
                ${price}
              </div>
            </a>
          </li>
        `;
      });
      
      resultsHTML += '</ul></div>';
      resultsHTML += '</div>'; // End recent searches column
    }
    
    // Add current search results column
    resultsHTML += `<div class="search-results-column current-search${!hasRecentSearches ? ' full-width' : ''}">`;
    
    // Process product results
    let hasCurrentResults = false;
    let allProducts = [];
    
    // Add direct product results
    if (data.resources.results.products && data.resources.results.products.length > 0) {
      allProducts = [...data.resources.results.products];
    }
    
    // Check for matching collections and fetch their products
    if (data.resources.results.collections && data.resources.results.collections.length > 0) {
      const filteredCollections = data.resources.results.collections.filter(collection => {
        return !excludedFromSearch.some(excluded => collection.url.includes(excluded));
      });
      
      // Fetch products from matching collections
      for (const collection of filteredCollections) {
        try {
          // Extract collection handle - handle both full URLs and relative URLs
          let collectionHandle = collection.handle || collection.url.split('/collections/')[1] || collection.url.split('/').pop();
          
          
          if (collectionHandle) {
            const collectionProductsUrl = `/collections/${collectionHandle}/products.json`;
            
            const collectionResponse = await fetch(collectionProductsUrl);
            const collectionData = await collectionResponse.json();
            
            
            if (collectionData.products && collectionData.products.length > 0) {
              // Add collection products to allProducts array
              const collectionProducts = collectionData.products.slice(0, 5).map(product => ({
                ...product,
                url: `/products/${product.handle}`,
                image: product.images && product.images.length > 0 ? product.images[0].src : null,
                price: product.variants && product.variants.length > 0 ? 
                  new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(product.variants[0].price) : null
              }));
              allProducts = [...allProducts, ...collectionProducts];
            }
          }
        } catch (error) {
          console.error('Error fetching collection products:', error);
        }
      }
    }
    
    // Display all products (direct + collection products)
    if (allProducts.length > 0) {
      hasCurrentResults = true;
      resultsHTML += '<div class="search-results-group"><h3>Produkte</h3><ul>';
      
      // Remove duplicates and limit results
      const uniqueProducts = allProducts.filter((product, index, self) => 
        index === self.findIndex(p => p.url === product.url)
      ).slice(0, 8);
      
      uniqueProducts.forEach(product => {
        // Find matching SKU variant if query matches a SKU
        let matchingSku = '';
        if (product.variants) {
          const matchingVariant = product.variants.find(variant => 
            variant.sku && variant.sku.toLowerCase().includes(query.toLowerCase())
          );
          if (matchingVariant) {
            matchingSku = matchingVariant.sku;
          }
        }

        // Save product to potentially add to recent searches when clicked
        const productData = {
          url: product.url,
          title: product.title,
          image: product.image || '',
          price: product.price || '',
          sku: matchingSku || '',
          type: 'Produkt'
        };
        
        const productImage = product.image ? `<img src="${product.image}" alt="${product.title}" class="search-result-image">` : '';
        const price = product.price ? `<span class="search-result-price">${product.price}</span>` : '';
        const sku = matchingSku ? `<span class="search-result-sku">SKU: ${matchingSku}</span>` : '';
        
        resultsHTML += `
          <li class="search-result-item">
            <a href="${product.url}" 
               class="search-result-link" 
               data-item='${JSON.stringify(productData).replace(/'/g, "&apos;")}'>
              ${productImage}
              <div class="search-result-details">
                <span class="search-result-title">${product.title}</span>
                ${sku}
                ${price}
              </div>
            </a>
          </li>
        `;
      });
      resultsHTML += '</ul></div>';
    }
      
      // Process collection results
      if (data.resources.results.collections && data.resources.results.collections.length > 0) {
        // Filter out excluded collections
        const filteredCollections = data.resources.results.collections.filter(collection => {
          return !excludedFromSearch.some(excluded => collection.url.includes(excluded));
        });
        
        if (filteredCollections.length > 0) {
          hasCurrentResults = true;
          resultsHTML += '<div class="search-results-group"><h3>Kollektionen</h3><ul>';
          filteredCollections.forEach(collection => {
            const collectionImage = collection.image ? `<img src="${collection.image}" alt="${collection.title}" class="search-result-image">` : '';
            
            // Save collection data for recent searches
            const collectionData = {
              url: collection.url,
              title: collection.title,
              image: collection.image || '',
              type: 'Kollektion'
            };
            
            resultsHTML += `
              <li class="search-result-item">
                <a href="${collection.url}" 
                   class="search-result-link" 
                   data-item='${JSON.stringify(collectionData).replace(/'/g, "&apos;")}'>
                  ${collectionImage}
                  <div class="search-result-details">
                    <span class="search-result-title">${collection.title}</span>
                  </div>
                </a>
              </li>
            `;
          });
          resultsHTML += '</ul></div>';
        }
      }

      // Process page results
      if (data.resources.results.pages && data.resources.results.pages.length > 0) {
        // Filter out excluded pages
        const filteredPages = data.resources.results.pages.filter(page => {
          return !excludedFromSearch.some(excluded => page.url.includes(excluded));
        });
        
        if (filteredPages.length > 0) {
          hasCurrentResults = true;
          resultsHTML += '<div class="search-results-group"><h3>Seiten</h3><ul>';
          filteredPages.forEach(page => {
            // Save page data for recent searches
            const pageData = {
              url: page.url,
              title: page.title,
              type: 'Seite'
            };
            
            resultsHTML += `
              <li class="search-result-item">
                <a href="${page.url}" 
                   class="search-result-link" 
                   data-item='${JSON.stringify(pageData).replace(/'/g, "&apos;")}'>
                  <span class="search-result-title">${page.title}</span>
                </a>
              </li>
            `;
          });
          resultsHTML += '</ul></div>';
        }
      }
      
      // Show no results message if nothing found
      if (!hasCurrentResults) {
        resultsHTML += '<div class="search-no-results">Keine Ergebnisse gefunden</div>';
      }
      
      resultsHTML += '</div>'; // End current search column
      
      // Add view all results link outside of columns - customSearchPage
      resultsHTML += `<div class="search-view-all"><a href="/search" aria-label="Alle Produkte anzeigen">Alle Produkte anzeigen</a></div>`;
      
      resultsHTML += '</div>'; // End container
      
      searchResults.innerHTML = resultsHTML;
      
      // Add click handlers for all search result links to save to recent searches
      document.querySelectorAll('.search-result-link[data-item]').forEach(link => {
        link.addEventListener('click', function() {
          try {
            const itemData = JSON.parse(this.getAttribute('data-item'));
            addToRecentSearches(itemData);
          } catch (e) {
            console.error('Error processing item data', e);
          }
        });
      });
    } catch (error) {
      console.error('Search error:', error);
      searchResults.innerHTML = '<div class="search-error">Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.</div>';
    }
}

// Event listener for search input with debounce
searchInput.addEventListener('input', function() {
  const query = this.value.trim();
  
  // Hide results if query is empty
  if (!query) {
    searchResults.style.display = 'none';
    searchResults.innerHTML = '';
    return;
  }

  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => {
    performSearch(query);
  }, 300); // 300ms debounce
});

// Handle search submission (redirect to search page)
function handleSearchSubmit() {
  const query = searchInput.value.trim();
  if (query) {
    // Redirect to search page with query parameter
    window.location.href = `/search?q=${encodeURIComponent(query)}`;
  }
}

// Handle search close button click (now acts as search submit)
searchCloseButton.addEventListener('click', function(e) {
  e.preventDefault();
  handleSearchSubmit();
});

// Handle Enter key press on search input
searchInput.addEventListener('keypress', function(e) {
  if (e.key === 'Enter') {
    e.preventDefault();
    handleSearchSubmit();
  }
});

window.addEventListener('click', function(e) {
  if (!mobileSearchIcon.contains(e.target) && !desktopSearchIcon.contains(e.target) && !searchBar.contains(e.target)) {
    searchBar.classList.remove('active');
    searchOverlay.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }
});

// Event listener for mobile search icon
mobileSearchIcon.addEventListener('click', function() {
  document.body.classList.add('no-scroll');
  searchBar.classList.add('active');
  searchOverlay.classList.add('active');
  searchInput.focus();
});

// Event listener for desktop search icon
desktopSearchIcon.addEventListener('click', function() {
  document.body.classList.add('no-scroll');
  searchBar.classList.add('active');
  searchOverlay.classList.add('active');
  searchInput.focus();
});

